import React from 'react';
import styled from 'styled-components';
import clsx from 'clsx';
import { Step, Stepper } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import * as ss from './vertical-stepper-styles';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledStepper = styled(Stepper)`
  padding-left: 110px;
`;

const ChildrenWrapper = styled.div`
  min-width: 600px;
  flex: 4;
  display: flex;
  justify-content: center;
`;

const StepperWrapper = styled.div`
  flex: 1;
  visibility: ${(props) => (props.visibility ? 'hidden' : 'visible')};
`;

function QontoStepIcon(props) {
  const classes = ss.useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div className={clsx(classes.root, { [classes.active]: active })}>
      {completed ?
        <Check className={classes.completed} /> :
        <div className={classes.circle} />
      }
    </div>
  );
}

const steps = [
  'Account Number',
  'Report revenue',
  'Confirmation and sign',
  'Contact',
  'Payment',
];

export function VerticalStepper(props) {
  const { activeStep, hidden } = props;

  return (
    <Wrapper>
      <ChildrenWrapper>
        {props.children}
      </ChildrenWrapper>

      <StepperWrapper hidden={hidden}>
        <StyledStepper
          activeStep={activeStep}
          orientation="vertical"
          connector={<ss.QontoConnectorV2 />}
        >
          {steps.map((label) => (
            <Step key={label}>
              <ss.StepperLabel StepIconComponent={QontoStepIcon}>
                {label}
              </ss.StepperLabel>
            </Step>
          ))}
        </StyledStepper>
      </StepperWrapper>
    </Wrapper>
  );
}
